(function () {

    "use strict";

    function mulberry32(seed) {

        return function () {

            let t = seed += 0x6D2B79F5;

            t = Math.imul(t ^ t >>> 15, t | 1);

            t ^= t + Math.imul(t ^ t >>> 7, t | 61);

            return ((t ^ t >>> 14) >>> 0) / 4294967296;

        };

    }

    function getReviewCount(random) {

        const seed = random();

        if (seed < 0.25) return 0;
        if (seed < 0.40) return 1;
        if (seed < 0.50) return 2;
        if (seed < 0.58) return 3;
        if (seed < 0.65) return 4;
        if (seed < 0.71) return 5;
        if (seed < 0.76) return 6;
        if (seed < 0.81) return 7;
        if (seed < 0.85) return 8;
        if (seed < 0.89) return 10;
        if (seed < 0.92) return 12;
        if (seed < 0.95) return 15;
        if (seed < 0.97) return 18;
        if (seed < 0.99) return 20;

        return 25;

    }

    function getAverageRating(random, reviews) {

        if (reviews === 0) {

            return 0;

        }

        let total = 0;

        for (let i = 0; i < reviews; i++) {

            const value = random();

            if (reviews <= 2) {

                if (value < 0.60) total += 5;
                else if (value < 0.80) total += 4;
                else if (value < 0.90) total += 3;
                else if (value < 0.97) total += 2;
                else total += 1;

            } else {

                if (value < 0.20) total += 5;
                else if (value < 0.40) total += 4;
                else if (value < 0.60) total += 3;
                else if (value < 0.80) total += 2;
                else total += 1;

            }

        }

        return (total / reviews).toFixed(1);

    }

        function buildStars(rating) {

        if (!rating) {

            return "☆☆☆☆☆";

        }

        let html = "";

        const full = Math.floor(rating);

        const half = rating - full >= 0.5;

        for (let i = 1; i <= 5; i++) {

            if (i <= full) {

                html += `
                <svg class="acr-star" viewBox="0 0 15 14" width="15" height="14">
                    <path fill="#FFB400"
                    d="M7.16604 12.1708C7.48383 11.979 7.88171 11.979 8.19951 12.1708L10.858 13.7754C11.6153 14.2325 12.5495 13.5535 12.3486 12.692L11.6431 9.6678C11.5587 9.30631 11.6816 8.92784 11.9621 8.68479L14.3124 6.64873C14.981 6.06952 14.6236 4.97126 13.7422 4.89648L10.65 4.63414C10.2804 4.60278 9.95851 4.36944 9.81377 4.02794L8.60349 1.17237C8.2589 0.359342 7.10664 0.359342 6.76205 1.17237L5.55177 4.02794C5.40703 4.36944 5.08517 4.60278 4.71559 4.63414L1.62335 4.89648C0.741922 4.97126 0.384515 6.06952 1.05311 6.64873L3.40341 8.68479C3.68397 8.92784 3.80682 9.30631 3.72249 9.6678L3.01697 12.692C2.81601 13.5535 3.75024 14.2325 4.50756 13.7754L7.16604 12.1708Z"/>
                </svg>`;

            } else {

                html += `
                <svg class="acr-star" viewBox="0 0 15 14" width="15" height="14">
                    <path fill="#E5E7EB"
                    d="M7.16604 12.1708C7.48383 11.979 7.88171 11.979 8.19951 12.1708L10.858 13.7754C11.6153 14.2325 12.5495 13.5535 12.3486 12.692L11.6431 9.6678C11.5587 9.30631 11.6816 8.92784 11.9621 8.68479L14.3124 6.64873C14.981 6.06952 14.6236 4.97126 13.7422 4.89648L10.65 4.63414C10.2804 4.60278 9.95851 4.36944 9.81377 4.02794L8.60349 1.17237C8.2589 0.359342 7.10664 0.359342 6.76205 1.17237L5.55177 4.02794C5.40703 4.36944 5.08517 4.60278 4.71559 4.63414L1.62335 4.89648C0.741922 4.97126 0.384515 6.06952 1.05311 6.64873L3.40341 8.68479C3.68397 8.92784 3.80682 9.30631 3.72249 9.6678L3.01697 12.692C2.81601 13.5535 3.75024 14.2325 4.50756 13.7754L7.16604 12.1708Z"/>
                </svg>`;

            }

        }

        return html;

    }

    document.addEventListener("DOMContentLoaded", function () {

        document
            .querySelectorAll(".ankur-collection-rating")
            .forEach(function (box) {

                const productId =
                    parseInt(box.dataset.productId, 10);

                const summary =
                    ANKUR_REVIEW_ENGINE.getSummary(productId);

                const reviews =
                    summary.count;

                const rating =
                    summary.average;

                box.innerHTML = `

<div class="acr-mini-rating">

    <span class="acr-stars"> ${buildStars(parseFloat(rating))} </span>

    <span class="acr-score">
        ${reviews ? rating : ""}
    </span>

    <span class="acr-count">
        (${reviews})
    </span>

</div>

                `;

            });

    });

})();